import React from 'react'
// import { Header } from 'semantic-ui-react'
import Layout from '../components/layout/layout'
import CardGroup from '../components/card-group/card-group'
import { MENU_ITEMS } from '../dummies/menuItems'

const Home = () => (
  <Layout>
    <div style={{ height: '90vh' }}>
      <CardGroup items={MENU_ITEMS} />
    </div>
  </Layout>
)

export default Home
